import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import { useField } from "formik";
import { TextField } from "@mui/material";

export default function FormSelect({ name, label, items = [] }) {
  const [field, meta] = useField(name);

  return (
    <TextField
      select
      id="select"
      size="small"
      label={label}
      {...field}
      error={Boolean(meta.touched && meta.error)}
      helperText={meta.touched && meta.error}
    >
      {items.map((item, index) => (
        <MenuItem value={item.code} key={index}>
          {item.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
